export function getDisplayDate(incommingDate: string | Date): string {
  const date = new Date(incommingDate);
  // 1 => 01, 3 => 03, 11 => 11;
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  return `${date.toLocaleDateString()} ${hours}:${minutes}`;
}
